var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33359_113734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9959 22.9995H1.00293V1.00391H22.9959V22.9995Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9888 1L22.4136 3.9142L22.2891 4.02265L6.8418 1.00002H11.9893",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14742 1.00293L20.6439 5.45736L20.5332 5.55387L2.59281 2.38596L1.35352 1.00297H4.14808",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8545 7.01608L18.7355 7.11974L4.97887 5.03424L2.83789 2.65918L18.8544 7.01613",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0823 8.56083C17.0626 8.59466 17.0023 8.63987 16.9585 8.66872L7.36264 7.67619L5.22852 5.30859L17.0823 8.56092",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2108 10.1904L15.0953 10.2911L9.74051 10.3173L7.62012 7.96484L15.2054 10.1952L15.211 10.1904",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96194 10.5605L13.5484 11.639L12.0839 12.9147L9.96191 10.5606",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83448 2.19445H1.77204V1.96349H1.7708L1.68791 2.19445H1.65103L1.56814 1.96349H1.56689V2.19445H1.50459V1.9082H1.6052L1.66969 2.07753L1.73411 1.9082H1.83479V2.19445H1.83448ZM1.46958 1.96349H1.3824V2.19445H1.31368V1.96349H1.22656V1.90821H1.46957L1.46958 1.96349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71289 17.6321L4.87427 21.1146V17.8433H5.3993V22.4535L2.23792 18.9708V22.2714H1.71289V17.6318",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29129 20.985C6.29719 21.4548 6.61431 21.8953 7.1194 21.8953C7.52455 21.8953 7.74191 21.6897 7.94155 21.3609L8.38792 21.6134C8.1295 22.0891 7.64791 22.3651 7.11348 22.3651C6.27364 22.3651 5.7627 21.7309 5.7627 20.9204C5.7627 20.0747 6.21492 19.4404 7.10173 19.4404C7.97673 19.4404 8.3879 20.0865 8.3879 20.9028V20.985L6.29129 20.985ZM7.85937 20.5856C7.79476 20.1745 7.52455 19.8985 7.10178 19.8985C6.69068 19.8985 6.38529 20.1922 6.3207 20.5856H7.85939",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.471 21.0144L12.7219 17.749L13.9729 21.0144L15.2121 17.843H15.8111L13.9729 22.4474L12.7219 19.1997L11.471 22.4474L9.63281 17.843H10.2318L11.471 21.0144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8551 22.2712H17.3265V21.8424H17.3148C17.1033 22.1537 16.7745 22.3651 16.3809 22.3651C15.5411 22.3651 15.0654 21.6662 15.0654 20.8793C15.0654 20.1276 15.5646 19.4404 16.3634 19.4404C16.7685 19.4404 17.0975 19.6518 17.3148 19.9807H17.3265V19.5226H17.8551V22.2712ZM17.3559 20.8969C17.3559 20.3624 17.0329 19.9103 16.4632 19.9103C15.917 19.9103 15.594 20.3859 15.594 20.8969C15.594 21.4137 15.9052 21.8953 16.4632 21.8953C17.0387 21.8953 17.3559 21.4372 17.3559 20.8969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8049 19.969H18.8225C18.9518 19.646 19.2219 19.4404 19.5743 19.4404C19.727 19.4404 19.8797 19.4933 20.0089 19.5755L19.7681 20.0571C19.6741 19.9749 19.5684 19.9455 19.4451 19.9455C18.8754 19.9455 18.8049 20.4741 18.8049 20.9204V22.2712H18.2764V19.5226H18.8049V19.969",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4445 20.985C20.4504 21.4548 20.7676 21.8953 21.2726 21.8953C21.6778 21.8953 21.8952 21.6897 22.0948 21.3609L22.5412 21.6134C22.2827 22.0891 21.8012 22.3651 21.2667 22.3651C20.4269 22.3651 19.916 21.7309 19.916 20.9204C19.916 20.0747 20.3682 19.4404 21.255 19.4404C22.13 19.4404 22.5412 20.0865 22.5412 20.9028V20.985L20.4445 20.985ZM22.0126 20.5856C21.948 20.1745 21.6778 19.8985 21.255 19.8985C20.8439 19.8985 20.5385 20.1922 20.4739 20.5856H22.0126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41245 22.2713H8.88548V20.0229H8.59863V19.5311H8.88548V18.666H9.41245V19.5311H9.92768V20.0229H9.41245V22.2713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9844 19.1767C21.9844 19.0282 22.102 18.9092 22.2506 18.9092C22.3985 18.9092 22.5168 19.0282 22.5168 19.1767C22.5168 19.324 22.3985 19.443 22.2506 19.443C22.102 19.443 21.9844 19.324 21.9844 19.1767ZM22.4536 19.1767C22.4536 19.0571 22.3649 18.9724 22.2506 18.9724C22.1343 18.9724 22.0476 19.0571 22.0476 19.1767C22.0476 19.2951 22.1343 19.3798 22.2506 19.3798C22.3649 19.3798 22.4536 19.2951 22.4536 19.1767ZM22.3783 19.3119H22.3111L22.2492 19.1949H22.2062V19.3119H22.1444V19.0349H22.2788C22.3427 19.0349 22.3863 19.0463 22.3863 19.1196C22.3863 19.1707 22.3601 19.1915 22.3111 19.1949L22.3783 19.3119ZM22.2802 19.1533C22.3111 19.1533 22.3286 19.1465 22.3286 19.1116C22.3286 19.0833 22.2929 19.0833 22.266 19.0833H22.2062V19.1533H22.2802Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33359_113734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.993,
    height: 22,
    fill: "white",
    transform: "translate(1.00293 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetware);
export default __webpack_public_path__ + "static/media/Netware.6f2d0f87611663593dc14d4cbefd768a.svg";
export { ForwardRef as ReactComponent };